// extracted by mini-css-extract-plugin
module.exports = {"video_row":"VideoRow_video_row__7lpfv"};